export default __webpack_public_path__ + "static/media/Bed.e2851e6e.svg";